import React, { useEffect, useState } from "react";
import * as S from "./styles";
import { CircularProgress, Grid } from "@mui/material";
import { api, apiPublic } from "@/services/api";
import { MatchData } from "@/interfaces/liveGamesType";
import { useNavigate } from "react-router-dom";

export default function SampleLiveGames() {
  const [liveGames, setLiveGames] = useState<MatchData[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const getLiveGames = async () => {
      try {
        setIsLoading(true);
        const games = await apiPublic.get("/football/getLiveMatchesFree");

        // Verificar a estrutura da resposta e extrair os dados corretamente
        const allLiveMatches = games.data.body?.data || games.data?.data || [];

        if (games.data.body?.error || games.data?.error) {
          return;
        }

        setLiveGames(allLiveMatches);
      } catch (e) {
        console.error("Erro ao carregar jogos ao vivo:", e);
      } finally {
        setIsLoading(false);
      }
    };

    getLiveGames();

    const interval = setInterval(() => {
      getLiveGames();
    }, 60000);

    return () => {
      clearInterval(interval);
    };
  }, []);
  return (
    <>
      <S.LiveGames>
        <h2>Jogos</h2>
        {isLoading ? (
          <S.LoadingContainer>
            <CircularProgress />
          </S.LoadingContainer>
        ) : liveGames.length ? (
          liveGames.map((el, i) => (
            <S.LiveCards key={el.match_id}>
              <Grid container>
                <Grid item sm={8} flexDirection="column">
                  <S.LiveTeams>
                    <img src={el.team_home_badge} />
                    <span>{el.match_hometeam_name}</span>
                  </S.LiveTeams>
                  <S.LiveTeams>
                    <img src={el.team_away_badge} />
                    <span>{el.match_awayteam_name}</span>
                  </S.LiveTeams>
                </Grid>
                <Grid item sm={4} display="flex" alignItems="center">
                  <p>
                    {el.match_hometeam_score} x {el.match_awayteam_score}
                  </p>
                </Grid>
              </Grid>
            </S.LiveCards>
          ))
        ) : (
          <S.NotFoundContainer>
            <CircularProgress />
          </S.NotFoundContainer>
        )}
        <S.GamesButton onClick={() => navigate("/dashboard")}>
          Todos os Jogos
        </S.GamesButton>
      </S.LiveGames>
    </>
  );
}
